<template>
  <kiosk-text-box v-if="element.properties.element_type === 'text_box'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="Object.freeze(element)"
    :sessionUuid="sessionUuid" />
  <kiosk-image v-else-if="element.properties.element_type === 'image'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="Object.freeze(element)"
    :sessionUuid="sessionUuid" />
  <kiosk-video v-else-if="element.properties.element_type === 'video'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="Object.freeze(element)"
    :sessionUuid="sessionUuid" />
  <kiosk-button v-else-if="element.properties.element_type === 'button'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-div v-else-if="element.properties.element_type === 'div'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-timer v-else-if="element.properties.element_type === 'timer'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-audio v-else-if="element.properties.element_type === 'audio'"
    :key="element.uuid"
    :kioskProperties="Object.freeze(kioskProperties)"
    :element="Object.freeze(element)"
    :sessionUuid="sessionUuid" />
  <kiosk-text-input v-else-if="element.properties.element_type === 'form_textfield'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-checkbox v-else-if="element.properties.element_type === 'form_checkbox'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-form-text-box v-else-if="element.properties.element_type === 'form_textbox'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-select v-else-if="element.properties.element_type === 'form_select'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
  <kiosk-form-header v-else-if="element.properties.element_type === 'form_header'"
    :key="element.uuid"
    :kioskProperties="kioskProperties"
    :element="element"
    :sessionUuid="sessionUuid" />
</template>

<script>
import ElementEventHelper from '../mixins/element_event_helper';

export default {
  name: 'KioskElements',
  mixins: [ElementEventHelper],
  components: {
    KioskAudio: () => import('./kiosk-audio.vue'),
    KioskTimer: () => import('./kiosk-timer.vue'),
    KioskDiv: () => import('./kiosk-div.vue'),
    KioskButton: () => import('./kiosk-button.vue'),
    KioskImage: () => import('./kiosk-image.vue'),
    KioskTextBox: () => import('./kiosk-text-box.vue'),
    KioskVideo: () => import('./kiosk-video.vue'),
    KioskTextInput: () => import('./kiosk-form-text-input.vue'),
    KioskCheckbox: () => import('./kiosk-form-checkbox.vue'),
    KioskSelect: () => import('./kiosk-form-select.vue'),
    KioskFormTextBox: () => import('./kiosk-form-text-box.vue'),
    KioskFormHeader: () => import('./kiosk-form-text-box.vue'),
  },
  props: {
    element: Object,
    kioskProperties: Object,
    sessionUuid: String,
  },
};
</script>

<style lang="scss" scoped>

</style>
